//Definição centralizada das rotas da aplicação

export const paths = {
  // === Para desenvolvimento === Acessível só localmente
  dev: '/dev-only/',
  // === Gerais ===
  /**
   * Página inicial
   * Acesso: Público
   * Exemplo de uso: navigate(paths.home)
   */
  home: '/',
  /**
   * Página de erro 500
   * Acesso: Público
   * Exemplo de uso: navigate(paths.internalServerError)
   */
  internalServerError: '/500/',
  /**
   * Página de erro 404
   * Acesso: Público
   * Exemplo de uso: navigate(paths.notFound)
   */
  notFound: '/404/',

  // === Perfil /  ===
  /**
     * Fornece ao usuário informações sobre a conta do profissional de saúde, incluindo opções de segurança e privacidade.
     * Acesso: Privado
     * Exemplos de uso:
      navigate(paths.perfil.seguranca.minhaConta)
      navigate(paths.perfil.seguranca.redefinirSenhaConfirmacao)
      navigate(paths.perfil.privacidade.conta.apagar)
     */
  perfil: {
    privacidade: {
      conta: {
        apagar: {
          _: '/perfil/privacidade/conta/apagar/',
          confirmar: '/perfil/privacidade/conta/apagar/confirmar/',
        },
        desativar: {
          _: '/perfil/privacidade/conta/desativar/',
          confirmar: '/perfil/privacidade/conta/desativar/confirmar/',
        },
        reativar: {
          _: '/perfil/privacidade/conta/reativar/',
          confirmar: '/perfil/privacidade/conta/reativar/confirmar/',
        },
      },
    },
    seguranca: {
      minhaConta: '/perfil/seguranca/conta/',
      redefinirSenhaConfirmacao: '/perfil/seguranca/redefinir-senha/confirmacao/',
    },
  },

  // === Saúde ===
  /**
   * Painel inicial da jornada profissional de saúde
   * Acesso: Privado
   * Exemplos de uso:
    navigate(paths.saude.profissional.painelInicial)
    navigate(paths.saude.profissional.agenda)
  */
  saude: {
    profissional: {
      agenda: {
        _: '/saude/profissional/agenda/',
        detalhes: {
          _: '/saude/profissional/agenda/detalhes-consulta/[id]/',
          confirmacao: '/saude/profissional/agenda/detalhes-consulta/[id]/confirmacao/',
        },
      },
      agendaSync: '/saude/profissional/sync-agenda/',
      cadastrado: '/saude/profissional/cadastrado/',
      cadastrar: {
        _: '/saude/profissional/cadastrar/',
        atendimento: {
          _: '/saude/profissional/cadastrar/atendimento/',
          confirmacao: '/saude/profissional/cadastrar/atendimento/confirmacao/',
          sucesso: '/saude/profissional/cadastrar/atendimento/sucesso/',
        },
        diversidade: {
          _: '/saude/profissional/cadastrar/diversidade/',
          resumo:
            '/saude/profissional/cadastrar/diversidade/recortes-sociais/finalizado/',
          recortesSociais: '/saude/profissional/cadastrar/diversidade/recortes-sociais/',
        },
      },
      painelInicial: '/saude/profissional/painel-inicial/',
      /**
       * Telas de pré-cadastro
       * Acesso: Público
       * Exemplo de uso: navigate(paths.saude.profissional.preCadastro)
       */
      preCadastro: {
        _: '/saude/profissional/pre-cadastro/',
        atendimento: {
          _: '/saude/profissional/pre-cadastro/atendimento/',
          agenda: '/saude/profissional/pre-cadastro/atendimento/agenda/',
        },
        confirmacao: '/saude/profissional/pre-cadastro/confirmacao/',
        verificando: '/saude/profissional/pre-cadastro/verificando/',
      },

      /**
       * Telas de redefinição de senha
       * Acesso: Público
       * Exemplos de uso:
        navigate(paths.profissional.redefinirSenhaConfirmar)
        navigate(paths.profissional.redefinirSenhaAlterada)
      */
      redefinirSenha: {
        _: '/saude/profissional/redefinir-senha/',
        alterada: '/saude/profissional/redefinir-senha/alterada/',
        confirmar: '/saude/profissional/redefinir-senha/confirmar/',
        linkExpirado: '/saude/profissional/redefinir-senha/expirado/',
        verificar: '/saude/profissional/redefinir-senha/verificar/',
      },
    },
  },
} as const;

export type PathValues<T> = T extends string
  ? T
  : T extends Record<string, unknown>
    ? PathValues<T[keyof T]>
    : never;

export type AppPathValue = PathValues<typeof paths>;
